// extracted by mini-css-extract-plugin
module.exports = {"Icon":"index__Icon___19zx6"};